<template>
    <div>
        <CodeEditor v-model="content" :libs="libs"/>
    </div>
</template>
<script>
export default {
    components: {
        CodeEditor: () => import("@/components/form/Editor/Code")
    },
    props: {
        value: {
            type: String,
            default: function() {
                return null
            }
        }
    },
    data: function() {
        return {
            showEditor: false
        }
    },
    computed: {
        content: {
            get() {
                return this.value ||  `<template>
    <div>
        <slot name="DefaultField"></slot>
    </div>
</template>

<script>
export default {}
<\/script>`
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        libs() {
            return  [
                {
                    name: "bootstrap-vue",
                    varName: "*",
                    docs: "https://bootstrap-vue.org/docs/components"
                },
                {
                    name: "@protokol/context",
                    varName: "context",
                    docs: this.$env.get('DOCS_URL') + "/docs#libs-context"
                },
            ]
        }
    },
    methods: {
        
    }
    
}
</script>